module.exports = __webpack_public_path__ + "static/media/F4Dtransparent.dc63a84f.png";